import { useEffect, useState } from 'react'
import { createFileRoute, Outlet, useNavigate } from '@tanstack/react-router'
import { useAuth } from '@/context/auth-context'
import { supabase } from '@/services/supabase'

export const Route = createFileRoute('/onboarding')({
  component: RouteComponent,
})

function RouteComponent() {
  const navigate = useNavigate()
  const { user, loading } = useAuth()
  const [sessionChecked, setSessionChecked] = useState(false)
  const [hasSession, setHasSession] = useState(false)

  // Check if there's an active Supabase session before making redirect decisions
  useEffect(() => {
    supabase.auth.getSession().then(({ data: { session } }) => {
      setHasSession(!!session)
      setSessionChecked(true)
    })
  }, [])

  useEffect(() => {
    if (!sessionChecked) return // Wait for session check
    
    if (!loading && !user && !hasSession) {
      navigate({ to: '/login' })
      return
    }

    if (user && !loading) {
      if (!user?.profile_completed) {
        navigate({
          to: '/onboarding/profile',
        })
        return
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [user, loading, sessionChecked, hasSession])

  return (
    <>
      <Outlet />
    </>
  )
}
